<div style="height: 8px; background-color: rgba(16, 46, 94, 0.982)" class="col-12"></div>
<mat-card-header class="" style="cursor: grabbing" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  <div class="row col-md-12">
    <div class="col-6">
      <mat-card-title><h2 class="pl-20">Modifier un agent</h2></mat-card-title>
    </div>

    <div class="col-md-6 text-end mb-2 mr-0 ml-auto gx-0">
      <button (click)="onClose()" class="close-icon" class="py-0" mat-icon-button aria-label="Fermer la modale">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</mat-card-header>
<mat-dialog-content class="mat-typography suppression-scroll">
  <form [formGroup]="editForm" class="row">
    <div class="row col-12">
      <div class="col-6">
        <div class="row">
          <mat-label>Nom *</mat-label>
          <div class="form-text mb-1">Saisissez le nom de l'agent.</div>
          <mat-form-field class="w-100">
            <input type="text" matInput formControlName="nom" />
            @if (editForm.get('nom')?.hasError('required')) {
              <mat-error> Le nom est obligatoire. </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="col-6">
        <div class="row">
          <mat-label>Prénom *</mat-label>
          <div class="form-text mb-1">Saisissez le prénom de l'agent.</div>
          <mat-form-field class="w-100">
            <input type="text" matInput formControlName="prenom" />
            @if (editForm.get('prenom')?.hasError('required')) {
              <mat-error> Le prénom est obligatoire. </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row col-12">
      <div class="col-6">
        <div class="row">
          <mat-label>Login *</mat-label>
          <div class="form-text mb-1">Saisissez le login de l'agent.</div>
          <mat-form-field class="w-100">
            <input type="text" matInput formControlName="login" />
            @if (editForm.get('login')?.hasError('required')) {
              <mat-error> Le login est obligatoire. </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="col-md-6 mb-2 pr-md-2">
        <mat-label>Email *</mat-label>
        <div class="form-text mb-1">Saisissez l'adresse email de l'agent.</div>
        <mat-form-field class="w-100">
          <input type="email" matInput formControlName="email" />

          @if (editForm.get('email')?.hasError('required') && editForm.get('email')?.touched) {
            <mat-error>
              L'email est obligatoire.
            </mat-error>
          }
          @if (editForm.get('email')?.hasError('email') && editForm.get('email')?.touched) {
            <mat-error>
              Veuillez entrer une adresse email valide.
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="row col-12">
      <div class="col-6">
        <div class="row">
          <mat-label>Direction *</mat-label>
          <div class="form-text mb-1">Sélectionnez la direction.</div>
          <mat-form-field class="w-100">
            <input
              #autoCompleteVGDirection
              type="text"
              placeholder="Direction"
              aria-label="Direction"
              matInput
              [matAutocomplete]="autoDirection"
              formControlName="direction"
              (input)="directionFilter($event)"
              />
              @if (this.editForm.get('direction')?.value) {
                <button
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="effaceDirectionFiltre($event, 'direction')"
                  >
                  <mat-icon>close</mat-icon>
                </button>
              }
              <mat-autocomplete cdkScrollable #autoDirection="matAutocomplete" [displayWith]="directionDisplayFn">
                @for (item of directionList; track item) {
                  <mat-option [value]="item">
                    {{ item.libelle }}
                  </mat-option>
                }
              </mat-autocomplete>
              @if (editForm.get('direction')?.hasError('required')) {
                <mat-error> La direction est obligatoire. </mat-error>
              }
              @if (editForm.get('direction')?.hasError('invalidDirection')) {
                <mat-error> La direction sélectionnée est invalide. </mat-error>
              }
            </mat-form-field>
          </div>
        </div>

        <div class="col-md-6 mb-2 pr-md-2">
          <mat-label>Service *</mat-label>
          <div class="form-text mb-1">Sélectionnez le service.</div>
          <mat-form-field class="w-100">
            <input
              #autoCompleteService
              type="text"
              placeholder="Service"
              aria-label="Service"
              matInput
              [matAutocomplete]="autoService"
              formControlName="service"
              (input)="serviceFilter($event)"
              />
              @if (this.editForm.get('service')?.value) {
                <button
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="effaceFiltreService($event, 'service')"
                  >
                  <mat-icon>close</mat-icon>
                </button>
              }
              <mat-autocomplete #autoService="matAutocomplete" hideSingleSelectionIndicator requireSelection [displayWith]="serviceDisplayFn">
                @for (element of servicelList; track element) {
                  <mat-option [value]="element">{{ element.libelle }}</mat-option>
                }
              </mat-autocomplete>
              @if (editForm.get('service')?.hasError('required')) {
                <mat-error> Le service est obligatoire. </mat-error>
              }
              @if (editForm.get('service')?.hasError('invalidService')) {
                <mat-error> Le service sélectionné est invalide. </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
        <div class="row g-0 mt-0">
          <div class="col-12" style="margin-top: -8px">
            <mat-label class="label-etat">Etat</mat-label>
            <div style="margin-top: 20px">
              <mat-checkbox color="primary" formControlName="actif" class="wrap-checkbox-label"> Actif </mat-checkbox>
            </div>
            <div style="margin-top: 20px">
              <mat-checkbox color="primary" formControlName="verrouAdmin"
                >Verrouillé (ne sera pas activé/désactivé par la synchronisation)</mat-checkbox
                >
              </div>
            </div>
          </div>
          <div class="row g-0 mt-0">
            <div class="col-md-6" style="flex: 0 0 auto; width: 100%">
              <mat-label class="label-texte">Dernier commentaire de synchronisation</mat-label>
              <p>{{ data.rowElement.dernierCommentaireSynchro }}</p>
            </div>
          </div>
          <div class="row g-0 mt-0">
            <div class="col-md-6" style="flex: 0 0 auto; width: 100%">
              <mat-label class="label-texte">Date de dernière vue dans le fichier de synchronisation</mat-label>
              <p>{{ data.rowElement.dateDerniereSynchro | date: 'dd/MM/yyyy HH:mm' }}</p>
            </div>
          </div>

          <div class="row g-0 mt-0">
            <div class="col-md-6" style="margin-top: -8px; flex: 0 0 auto; width: 33.33333333%"></div>
          </div>
        </form>
        <h5 class="text-footer">Les champs annotés d'un astérique * sont obligatoires.</h5>
      </mat-dialog-content>
      <mat-dialog-actions style="background-color: rgba(250, 250, 252, 1)" align="end">
        <button mat-stroked-button mat-dialog-close class="mx-3" color="primary">Annuler</button>
        <button mat-flat-button color="primary" (click)="saveAgent()" [disabled]="!editForm.dirty || editForm.invalid">Valider</button>
      </mat-dialog-actions>
